<!--赢在录取-专业知晓文件查看-->
<template>
    <div class="app-container">
        <div class="rqzj-base-container">
            <div class="event-page-container">
                <div class="head-container">
                    <div class="left-head-container" @click="backList">
                        <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                    </div>
                    <div class="right-head-container">{{fileForm.fileName}}</div>
                    <div class="left-head-container">
                    </div>
                </div>
                <el-scrollbar class="museum-event-info-container">
                    <!--word/pdf/ppt文件：按页图片预览-->
                    <file-image-preview v-if="viewMode==='pages'" class="file-view-box"
                                        :title="fileForm.fileName" :img-url="fileForm.imgUrl" :pages="fileForm.pages" />
                    <!--图片文件：直接展示图片-->
                    <div v-else-if="viewMode==='image'" class="file-view-box image-view">
                        <img :src="fileForm.fileUrl" :alt="fileForm.fileName" />
                    </div>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>
<script>
import {serviceUrl} from "@/utils/global";
import {infoFile} from "@/api/admin/fileCategory";
import fileImagePreview from "@/components/material/fileImagePreview.vue"

export default {
    name: "professionKnowledgeView",
    components: {fileImagePreview},
    data() {
        return {
            serviceUrl,
            fileId:"",
            fileName:"",
            categoryId:"",
            pageNum:"",
            pageSize:"",
            //预览方式：image-图片直出，pages-按页图片预览
            viewMode:'',
            fileForm:{},
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.query.fileId) {
            this.fileId = this.$route.query.fileId
            this.fileName = this.$route.query.fileName
            this.categoryId = this.$route.query.categoryId
            this.pageNum = this.$route.query.pageNum
            this.pageSize = this.$route.query.pageSize
            this.queryFileInfo();
        }
    },
    mounted(){},
    methods: {
        queryFileInfo(){
            infoFile({fileId:this.fileId}).then((res)=>{
                if (res.data.code === 1) {
                    this.fileForm = res.data.data;
                    // fileType为文件后缀名，统一转小写并去掉可能带有的前缀点，不区分大小写
                    const fileType = (this.fileForm.fileType || '').toLowerCase().replace(/^\./, '');
                    // 图片文件：直接展示图片
                    if (/^(png|jpe?g|gif|bmp|webp|svg)$/.test(fileType)) {
                        this.viewMode = 'image';
                        return;
                    }
                    // word/pdf/ppt文件：按页图片预览
                    if (/^(doc|docx|pdf|ppt|pptx)$/.test(fileType)) {
                        if (this.fileForm.imgUrl && Number(this.fileForm.pages) > 0) {
                            this.viewMode = 'pages';
                        } else {
                            this.$message.info("文件正在处理，请稍后刷新预览")
                        }
                        return;
                    }
                    // 其他文件暂不支持预览
                    this.$message.info("暂不支持预览，可下载使用")
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        backList(){
            this.$router.push({
                path: "/professionKnowledge",
                query: {
                    fileName: this.fileName,
                    categoryId: this.categoryId,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                }
            });
        },
    }
}
</script>
<style>
.rqzj-base-container{
    width: 100%;
    height: calc(100vh - 95px);
    background-color: #fff;
    overflow-y: auto!important;
    padding-bottom: 10px;
    padding-top: 5px;
    font-family: sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
}
.event-page-container{
    width: 100%;
    height: calc(100vh - 100px);
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #0d55a4;
    line-height: 44px;
    font-weight: bold;
}
.museum-event-info-container{
    width: 100%;
    height: calc(100% - 30px)!important;
    padding: 0 10px 10px 10px;
    box-sizing: border-box;
}
/*提高选择器优先级，确保覆盖组件根节点自带的 height:100%，容器高度固定，
  滚动只发生在组件内部，切换图标才能一直悬浮在可视模块中间高度*/
.museum-event-info-container .file-view-box{
    width: 100%;
    height: calc(100vh - 150px);
}
/*图片直出预览*/
.image-view{
    display: flex;
    justify-content: center;
    overflow: auto;
    background: #f2f8ff;
    border-radius: 12px;
}
.image-view img{
    max-width: 100%;
    display: block;
    object-fit: contain;
}
</style>